import { useEffect } from "react";

export const useMetaDescription = (description: string | undefined) => {
  useEffect(() => {
    if (!description) return;

    let metaTag = document.querySelector('meta[name="description"]');

    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.name = "description";
      document.head.appendChild(metaTag);
    }

    const previousContent = metaTag.content;
    metaTag.content = description;

    return () => {
      if (metaTag) {
        metaTag.content = previousContent;
      }
    };
  }, [description]);
};
